export const TITLE = "EINSTELLUNGEN";
export const SETTINGS_1 = "Exporteinstellungen";
export const SETTINGS_2 = "Backendnutzer";
export const SETTINGS_3 = "Sonstiges";
export const BTN_ADD_DAMAGE = "Schadentyp hinzufügen";
export const POPUP_DAMAGE_TITLE = "Neuen Schadentyp anlegen";
export const POPUP_DAMAGE_INPUT_TOP = "Bezeichnung";
export const POPUP_EDIT_DAMAGE_TITLE = "Schadentyp bearbeiten";
export const POPUP_CONFIRM_DELETE_DAMAGE_MESSAGE = "Möchten Sie diese Schadenart wirklich löschen?";